// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"f2bc7d36","212":"fdf15f54","425":"dc82529d","460":"ed240088","557":"91129f95","870":"2e477b9e"}[chunkId] + ".chunk.js";
};